import React from 'react'

import { CompanyTypeIndicator } from '@/atoms/CompanyTypeIndicator/CompanyTypeIndicator'
import { useTranslation } from '@/lib/i18n/i18n'
import { DefaultProps } from '@/travelsuit'

interface IProps extends DefaultProps {
	isAdmin: boolean
	isSupportUser: boolean
	companyType: string
}

const CompanyTooltipText = ({ isAdmin, isSupportUser, companyType }: IProps) => {
	const { t } = useTranslation()
	if (companyType === 'restricted') {
		return (
			<>
				<p>
					{t('company-type-popup.popup-text.status')}
					<CompanyTypeIndicator label={t('company-type-popup.restricted')} companyType={companyType} />
					<br />
					{t('company-type-popup.popup-text.restricted.explain')}
					<br />
				</p>

				<p>
					{isAdmin || isSupportUser
						? t('company-type-popup.popup-text.restricted.adminMode')
						: t('company-type-popup.popup-text.restricted.userMode')}
				</p>
			</>
		)
	}

	if (companyType === 'demo') {
		return (
			<p>
				{t('company-type-popup.popup-text.status')}
				<CompanyTypeIndicator label={t('company-type-popup.demo')} companyType={companyType} />
				<br />
				{t('company-type-popup.popup-text.demo.explain')}
			</p>
		)
	}

	return <></>
}

export default CompanyTooltipText
